<app-supervisor-header></app-supervisor-header>
<app-spinner style="z-index: 1000;position: fixed;"></app-spinner>

<router-outlet></router-outlet>
